export type SimpleStorage = {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
};

const createMemoryStorage = (): SimpleStorage => {
  const mem: Record<string, string> = {};
  return {
    getItem: (key) => (key in mem ? mem[key] : null),
    setItem: (key, value) => {
      mem[key] = value;
    },
    removeItem: (key) => {
      delete mem[key];
    },
  };
};

export const safeLocalStorage: SimpleStorage = (() => {
  try {
    // In some browsers/privacy modes, access to storage inside an iframe can throw.
    const ls = window.localStorage;
    const testKey = "__bb_storage_test__";
    ls.setItem(testKey, "1");
    ls.removeItem(testKey);
    return ls;
  } catch {
    return createMemoryStorage();
  }
})();
